// extracted by mini-css-extract-plugin
export default {"popover":"QIwb5W3RvjMmxhfClBReSQ=="};